import React from 'react'
import { get } from 'lodash-es'
import type { Marker as MarkerType, Photo } from '@app-types/entity_types'
import FormattedTime from '@components/FormattedTime'
import Image from '@components/Image'
import { sanitize, markupAndSanitize } from '@utils/sanitize.js'

type MarkerProps = {
  data: MarkerType
  photoData: Photo | null
  lazyLoadImage: boolean
}

const Marker: React.FC<MarkerProps> = props => {
  const { data, photoData, lazyLoadImage = true } = props

  const getImageContent = () => {
    if (photoData) {
      const imageProcessingComplete =
        get(photoData, ['image_processing_complete']) === true ||
        get(photoData, ['attributes', 'image_processing_complete']) === true
      if (imageProcessingComplete) {
        const image = get(photoData, ['image_urls', 'medium']) || get(photoData, ['attributes', 'image_urls', 'medium'])
        if (image) {
          const { src, width, height } = image
          const imgStyle = {
            width: '100%',
            height: 'auto',
            display: 'block',
          }
          const loading = lazyLoadImage ? 'lazy' : null
          return (
            <div className="timeline-item__image">
              <Image src={src} width={width} height={height} alt={data.title} style={imgStyle} loading={loading} />
            </div>
          )
        }
      }
    }
    return null
  }

  const getDescriptionContent = () => {
    const description = data.description
    if (description && description !== '') {
      return (
        <div
          className="timeline-item-detail__description block p-x marked-up"
          dangerouslySetInnerHTML={{ __html: markupAndSanitize(description) }}
        />
      )
    }
    return null
  }

  const image = getImageContent()
  const description = getDescriptionContent()

  return (
    <li className="timeline-item timeline-item--viewer">
      <div className="timeline-item__connector-line"></div>
      <div className="timeline-item__dot">
        <div className="dot__graphic"></div>
      </div>
      <div className="timeline-item__content-wrapper">
        <div className="timeline-item-detail timeline-item__content">
          {image}
          <div className="timeline-item-detail__content p-t p-b">
            <div className="timeline-item-detail__meta p-x">
              <div className="timeline-item-detail__time">
                <FormattedTime dateTime={data.date} />
              </div>
              <h2 className="timeline-item-detail__title">{sanitize(data.title)}</h2>
            </div>
            {description}
          </div>
        </div>
      </div>
    </li>
  )
}

export default React.memo(Marker)
